import React from 'react'

// import icon
import Dot from '../../../assets/images/logo/Dot.svg';

// import Variable
import { descriptionData } from '../Constant/key-features/index';

// style
import './index.css'

function index() {


  return (
    <div className='modal-data'>
      <dl>
        {descriptionData?.map((d, i) => {

          return (
            <>
              <dt className='description-title' key={i}><img src={Dot} alt="" />{d?.title}</dt>
              {
                d?.data?.map((v, index) => {
                  return <div className='description-data' key={index}>
                    <dd className='d-flex align-items-start'><span className='description-disc'></span>{v}</dd>
                  </div>
                })
              }
            </>
          )

        })}
      </dl>
    </div>
  )
}

export default index